module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/features/headers-styles/ecommerce-header-style1/ecommerce-header-style1.component.scss
// module id = ./src/app/features/headers-styles/ecommerce-header-style1/ecommerce-header-style1.component.scss
// module chunks = main